import { IoLocationOutline } from "react-icons/io5";
import { IoIosArrowBack } from "react-icons/io";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa6";
import { BsYoutube } from "react-icons/bs";

const footer = {
  usefulLinks: [
    {
      name: "Arena Cars",
      link: "/channels/arena",
    },
    {
      name: "Nexa Cars",
      link: "/channels/nexa",
    },
    {
      name: "Commercial Vehicles",
      link: "/channels/commercial",
    },
    {
      name: "Suzuki",
      link: "/channels/suzuki",
    },
  ],
  services: [
    {
      name: "Book A Service",
      link: "/book-a-service",
    },
    {
      name: "Finance",
      link: "/finance",
    },
    {
      name: "Insurance",
      link: "/insurance",
    },
    {
      name: "Truevalue",
      link: "/truevalue",
    },
  ],
};

function Footer() {
  return (
    <>
      <div className="bg-gradient-to-r from-[#263F73] to-[#263F73] ">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 container px-5 md:px-0 mx-auto text-gray-200 ">
          <div className="col-span-1 mb-10">
            <div className="ml-14">
            <img
              src={require("../../assets/logo.png")}
              className="h-20 bg-white  p-2 rounded-b-3xl  "
              alt="logo "
            /></div>
            <p className="flex items-start mt-3">
              <IoLocationOutline className="mr-2" fontSize={40} />
              Opp: KIMS Hospital, 64, Gachibowli - Miyapur Rd, Madhapur,
              Kondapur, Telangana 500084, India
            </p>
            <div className="mt-3 space-y-2">
              {/* Arena */}
              <a
                href="tel:9912345866"
                className="flex items-center hover:text-red-600"
              >
                <FaPhoneAlt className="mr-2" />
                <span className="font-medium">Arena:</span>&nbsp;9912345866
              </a>

              {/* Nexa */}
              <a
                href="tel:9912345830"
                className="flex items-center hover:text-red-600"
              >
                <FaPhoneAlt className="mr-2" />
                <span className="font-medium">Nexa:</span>&nbsp;9912345830
              </a>
            </div>
            <a
              href="mailto:gemmaruti.com@gmail.com"
              className="flex items-center mt-3 hover:text-red-600"
            >
              <FaEnvelope className="mr-2" />
              gemmaruti.com@gmail.com
            </a>
          </div>
          <div className="col-span-1 uppercase md:mt-12">
            <p className=" text-xl tracking-wider">Useful links</p>
            <p className="bg-[#E3020F] h-1 mt-2 max-w-[136px] rounded-full"></p>
            <div className="mt-7 space-y-3">
              {footer.usefulLinks.map((item, index) => (
                <div
                  className="flex  pb-2 border-gray-700 items-center hover:text-red-500 duration-200"
                  key={index}
                >
                  <IoIosArrowBack className="rotate-180" />
                  <Link to={item.link}>{item.name}</Link>
                </div>
              ))}
            </div>
          </div>
          <div className="col-span-1 uppercase  md:mt-12">
            <p className=" text-xl tracking-wider">services</p>
            <p className="bg-[#E3020F] h-1 mt-2 max-w-[96px] rounded-full"></p>
            <div className="mt-7 space-y-3">
              {footer.services.map((item, index) => (
                <div
                  className="flex  pb-2 border-gray-700 items-center hover:text-red-500 duration-200"
                  key={index}
                >
                  <IoIosArrowBack className="rotate-180" />
                  <Link to={item.link}>{item.name}</Link>
                </div>
              ))}
            </div>
          </div>
          <div className="col-span-1 md:mt-12 mb-5">
            <p className=" text-xl tracking-wider uppercase">social links</p>
            <p className="bg-[#E3020F] h-1 mt-2 max-w-[138px] rounded-full"></p>
            <div className="mt-7 space-y-3">
              <div className="flex items-center justify-start gap-5">
                <a
                  href="https://www.facebook.com/GemMarutiOfficial/"
                  className="hover:text-red-600"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <FaFacebook size={24} />
                </a>
                <span className="hover:text-red-600">
                  <FaLinkedin size={24} />
                </span>
                <a
                  href="https://www.instagram.com/gemmarutiofficial/"
                  className="hover:text-red-600"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <FaInstagram size={24} />
                </a>
                <a
                  href="https://www.youtube.com/@gemmarutisuzuki"
                  className="hover:text-red-600"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <BsYoutube size={24} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-footer bg-slate-900 text-white py-3 ">
        <div className="container mx-auto">
          <div className="text-center md:text-left md:flex items-center justify-between">
            <p>© Copyright {new Date().getFullYear()} GEM MOTORS PVT LTD.</p>
            <div className="flex items-center justify-center space-x-3 text-xs sm:text-base px-5 md:px-0">
              <Link className="hover:text-red-600" to="/contact-us">
                Contact Us
              </Link>
              <p className="w-px bg-white h-7"></p>
              <Link className="hover:text-red-600" to="/privacy-policy">
                Privacy Policy
              </Link>
              {/* <p className="w-px bg-white h-7"></p> */}
              {/* <Link className="hover:text-red-600" to="/">
                Powered by SR Creative Graphics
              </Link> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
